import { Radio } from '@ksyos/design-system';
import type { ValidationErrors } from '@frontend/utils';
import { YesOrNoOrStoppedOrUnknown } from '@common/enums';
import { RadioGroupFormGroup, TextAreaFormGroup, TextInputFormGroup } from '../../../processActivityFormGroupFields';

type DrugUseFormGroupProps = {
    data: {
        drugUseStoppedSince: string | null;
        isDrugUser: YesOrNoOrStoppedOrUnknown | null;
        isDrugUserRemark: string | null;
    };
    errors: ValidationErrors;
    onChange: (data: Partial<DrugUseFormGroupProps['data']>, validateKeys?: string | string[] | undefined) => void;
};

export function DrugUseFormGroup(props: Readonly<DrugUseFormGroupProps>): JSX.Element {
    const { data, errors, onChange } = props;

    return (
        <>
            <RadioGroupFormGroup
                error={errors.get('isDrugUser')}
                fieldKey="isDrugUser"
                hasErrors={errors.has('isDrugUser')}
                label="Drugsgebruik"
                onChange={async (value) => {
                    onChange(
                        {
                            isDrugUser: (value ?? null) as YesOrNoOrStoppedOrUnknown,
                            ...([YesOrNoOrStoppedOrUnknown.no].includes(value as YesOrNoOrStoppedOrUnknown)
                                ? { isDrugUserRemark: null }
                                : {}),
                            ...([YesOrNoOrStoppedOrUnknown.no, YesOrNoOrStoppedOrUnknown.yes].includes(
                                value as YesOrNoOrStoppedOrUnknown
                            )
                                ? { drugUseStoppedSince: null }
                                : {}),
                            ...([YesOrNoOrStoppedOrUnknown.unknown].includes(value as YesOrNoOrStoppedOrUnknown)
                                ? {
                                      drugUseStoppedSince: null,
                                      isDrugUserRemark: null,
                                  }
                                : {}),
                        },
                        'isDrugUser'
                    );
                }}
                value={data.isDrugUser ?? ''}
            >
                <Radio
                    key={YesOrNoOrStoppedOrUnknown.yes}
                    label={YesOrNoOrStoppedOrUnknown.yes}
                    value={YesOrNoOrStoppedOrUnknown.yes}
                />
                <Radio
                    key={YesOrNoOrStoppedOrUnknown.no}
                    label={YesOrNoOrStoppedOrUnknown.no}
                    value={YesOrNoOrStoppedOrUnknown.no}
                />
                <Radio
                    key={YesOrNoOrStoppedOrUnknown.stopped}
                    label={YesOrNoOrStoppedOrUnknown.stopped}
                    value={YesOrNoOrStoppedOrUnknown.stopped}
                />
                <Radio
                    key={YesOrNoOrStoppedOrUnknown.unknown}
                    label={YesOrNoOrStoppedOrUnknown.unknown}
                    value={YesOrNoOrStoppedOrUnknown.unknown}
                />
            </RadioGroupFormGroup>

            {data.isDrugUser === YesOrNoOrStoppedOrUnknown.stopped && (
                <TextInputFormGroup
                    fieldKey="drugUseStoppedSince"
                    label="Gestopt sinds"
                />
            )}

            {[YesOrNoOrStoppedOrUnknown.stopped, YesOrNoOrStoppedOrUnknown.yes].includes(
                data.isDrugUser as YesOrNoOrStoppedOrUnknown
            ) && (
                <TextAreaFormGroup
                    fieldKey="isDrugUserRemark"
                    label="Toelichting"
                />
            )}
        </>
    );
}
